import {PaymentRedirectFocusTitleDefaultBox} from "./payment-redirect-focus-title.default.box";

export const PaymentRedirectFocusTitleBox = PaymentRedirectFocusTitleDefaultBox;
